import React, { useEffect } from "react";
import PropTypes from "prop-types";

import Icon from "core/ReusableIcons/Icon";
import Photo from "core/ReusableIcons/Photo";
import Tabs from "core/Tabs";

import { PAGE_CONTENT_TYPES } from "../index";

const CreatorProfileNav = ({
    setPageContent,
    hasPublishedIcons,
    hasPublishedPhotos
}) => {
    const tabData = [];

    if (hasPublishedIcons) {
        tabData.push({
            name: "Icons",
            icon: Icon,
            tabId: PAGE_CONTENT_TYPES.ICONS
        });
    }

    if (hasPublishedPhotos) {
        tabData.push({
            name: "Photos",
            icon: Photo,
            tabId: PAGE_CONTENT_TYPES.PHOTOS
        });
    }

    useEffect(() => {
        tabData[0] && setPageContent(tabData[0].tabId);
    }, [tabData[0] && tabData[0].name]);

    return (
        <Tabs
            tabData={tabData}
            onTabClick={index => {
                setPageContent(tabData[index].tabId);
            }}
        />
    );
};

CreatorProfileNav.propTypes = {
    setPageContent: PropTypes.func.isRequired,
    hasPublishedIcons: PropTypes.bool,
    hasPublishedPhotos: PropTypes.bool
};

export default CreatorProfileNav;
